export enum SessionTabs {
	DASHBOARD = 'dashboard',
	INFO = 'info',
	SCHEDULE = 'schedule',
	SCHEDULER = 'scheduler',
	PARTICIPANTS = 'participants',
	TEAM_BUILDER = 'team-builder',
	CREATE_GROUP = 'create',
	PRODUCTS = 'products',
	PRICING = 'pricing',
	REPORTS = 'reports',
	COMPETITION = 'competition',
}

export enum SessionInnerTabs {
	CREATE = 'create',
	GROUPS = 'groups',
	COMPETITION_RULES = 'rules',
	COMPETITION_SCORES = 'scores',
	COMPETITION_PUBLIC_DISPLAY = 'public-display',
	INDIVIDUALS = 'individuals',
	WAITLIST = 'waitlist',
	SCHEDULE = 'schedule',
	SEGMENTS = 'segments',
}

export enum SessionVariant {
	CREATE = 'create',
	EDIT = 'edit',
	DUPLICATE = 'duplicate',
}

// TODO: export from backend
export enum MetaType {
	UNSPECIFIED = 0,
	GROUP = 1,
}

export enum ProductType {
	REGISTRATION = 'registration',
	PUNCH_PASS = 'punch_pass',
}
